import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

export default function ReferralBonusPolicy() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable name="ReferralBonusPolicy" title="Chính Sách Hoa Hồng" />
        </Container>
      </div>
    </React.Fragment>
  );
}
